import React from 'react';

/**
 * "Choose Your Reset" — three offer cards. The four-week cohort is featured.
 * Live offers link to on-page request forms; the app card is inactive until
 * the owner supplies the affiliate link (placeholders start with "[").
 */
export default function Offers({ offers }) {
  if (!offers?.items?.length) return null;
  return (
    <section className="band" style={{ background: 'var(--bg-alt)' }} data-testid="offers">
      <div className="wrap">
        <p className="eyebrow">{offers.eyebrow}</p>
        <h2 className="display">{offers.h2}</h2>
        {offers.intro && <p className="sub">{offers.intro}</p>}
        <div className="offers">
          {offers.items.map((o) => {
            const pending = !o.href || o.href.startsWith('[');
            return (
              <article key={o.key} className={`offer${o.featured ? ' featured' : ''}`} data-testid={`offer-${o.key}`}>
                <p className="offer-label">{o.label}</p>
                <h3 className="offer-title">{o.title}</h3>
                {o.price && <p className="offer-price display">{o.price}</p>}
                {o.price_note && <p className="offer-price-note">{o.price_note}</p>}
                <p className="offer-desc">{o.desc}</p>
                {o.details?.length > 0 && (
                  <ul className="offer-dates">
                    {o.details.map((x) => <li key={x}>{x}</li>)}
                  </ul>
                )}
                <div className="cta-wrap">
                  {pending ? (
                    <span className="cta pending" aria-disabled="true" data-testid={`offer-cta-${o.key}`}>
                      {o.cta} <span aria-hidden="true">→</span>
                    </span>
                  ) : (
                    <a className="cta" href={o.href} data-testid={`offer-cta-${o.key}`}
                       {...(o.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer sponsored' } : {})}>
                      {o.cta} <span aria-hidden="true">→</span>
                    </a>
                  )}
                  {pending && <p className="cta-note">Link coming soon.</p>}
                </div>
                {o.disclosure && <p className="offer-disclosure">{o.disclosure}</p>}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
